import React from 'react';
import { SrpSaveSearchUI } from 'site-modules/shared/components/inventory/srp-save-search/srp-save-search-ui';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';

export const PersonalizedSaveSearchDataProviderUI = props => {
  return <SrpSaveSearchUI {...props} />;
};

export const PersonalizedSaveSearchDataProvider = connectToModel(PersonalizedSaveSearchDataProviderUI, {
  selectedFacets: bindToPath(PersonalizedSearchPaths.getSelectedFilters(), PersonalizedSearchModel, null, false),
  searchResults: bindToPath(PersonalizedSearchPaths.getInventoryData(), PersonalizedSearchModel, null, false),
});
